import type { ProductKey } from '@/router/products'

/**
 * Règles « déjà souscrit » multi-produits (configurable).
 *
 * Par défaut, un produit est considéré « déjà souscrit » quand l'utilisateur
 * détient un contrat de CE produit (mapping `bundle_normalized_name` →
 * `ProductKey`, cf. `bundleReference.ts`).
 *
 * Cette table ajoute une **couverture transverse** : un produit y est marqué
 * « déjà souscrit » dès que l'utilisateur détient un contrat sur l'un des
 * `bundle_normalized_name` listés (typiquement des bundles d'un AUTRE produit).
 *
 * Pour appliquer la même logique à un autre parcours, il suffit d'ajouter une
 * entrée ici :
 *   <productKey>: ['<bundle_normalized_name>', ...]
 *
 * Les noms proviennent du catalogue backend (`/subscription/available_bundles`,
 * champ `normalized_name` ; même source que `bundleReference.ts`).
 */
/** Packs complémentaire santé (formule de base + option Indispensable/Sécurité). */
const COMPL_SANTE_PACKS = [
  'minimale_indispensable',
  'minimale_securite',
  'essentielle_indispensable',
  'essentielle_securite',
  'confort_indispensable',
  'confort_securite',
  'tous_risques_indispensable',
  'tous_risques_securite',
  'tonicetudes_indispensable',
  'tonicetudes_securite'
] as const

export const CROSS_PRODUCT_COVERAGE: Partial<Record<ProductKey, readonly string[]>> = {
  // Déjà couverts si l'utilisateur détient une complémentaire santé « pack ».
  solidariteExam: COMPL_SANTE_PACKS,
  civil: COMPL_SANTE_PACKS,
  // Déjà couvert si l'utilisateur détient une surcomplémentaire Tonic-Études.
  healthTopUp: ['tonic-etudes', 'tonicetudes_indispensable', 'tonicetudes_securite'],
}
